import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export function Footer() {
  return (
    <footer className="border-t border-border bg-card">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <Logo className="h-8" />
            </div>
            <p className="mt-4 max-w-sm text-sm text-muted-foreground">
              Connecting healthcare teaching institutes with doctors, nurses, technicians and administrators —
              discover, apply and progress your clinical career.
            </p>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">Platform</h4>
            <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
              <li><Link to="/courses" className="hover:text-foreground">Explore Courses</Link></li>
              <li><Link to="/institutes" className="hover:text-foreground">Institutes</Link></li>
              <li><Link to="/register" className="hover:text-foreground">Register Institute</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs font-semibold uppercase tracking-widest text-muted-foreground">Account</h4>
            <ul className="mt-4 space-y-2 text-sm text-muted-foreground">
              <li><Link to="/login" className="hover:text-foreground">Sign in</Link></li>
              <li><Link to="/register" className="hover:text-foreground">Create account</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 border-t border-border pt-6 text-xs text-muted-foreground">
          © 2026 Medlane. For educational discovery only — admission decisions rest with the respective institutes.
        </div>
      </div>
    </footer>
  );
}
